import Vue from 'vue'
import App from './App'
import { createRouter } from './router'
import { createStore } from './store'
import { sync } from 'vuex-router-sync'
import VueApollo from 'vue-apollo'
import apolloProvider from './graphql/apollo'
import { IMG_URL, NEW_UGIRL_URL, OLD_UGIRL_URL } from './service/index'

// 挂载静态资源地址
Vue.prototype.IMG_URL = IMG_URL;
Vue.prototype.NEW_UGIRL_URL = NEW_UGIRL_URL;
Vue.prototype.OLD_UGIRL_URL = OLD_UGIRL_URL;

Vue.config.productionTip = false;
Vue.use(VueApollo); // 使用GRAPHQL模块

export function createApp () {
  const router = new createRouter();
  const store = new createStore();

  sync(store, router);

  const app = new Vue({
    apolloProvider,
    router,
    store,
    render: h => h(App)
  });
  return { app, router, store}
}



// WEBPACK FOOTER //
// ./src/main.js